import React from 'react';
import { Page, Text, View, Document, Image, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 20,
  },
  section: {
    marginBottom: 7,
    //border: '1px solid #222',
  },
  sectionCol: {
    flexDirection: 'column',
  },
  headerSection: {
    flexDirection: "row",
    justifyContent: 'space-between',
  },
  flexRow: {
    flexDirection: "row",
    justifyContent: 'space-between',
  },
  flexRowContent: {
    flexDirection: "row",
    justifyContent: 'space-between',
  },
  leftSection: {
    width: '47.5%',
  },
  rightSection: {
    marginLeft: '5%',
    width: '47.5%',
  },
  dateSection: {
    flexDirection: 'row',
    gap: 10,
  },
  pageHeading: {
    fontSize: 18,
    textAlign: 'center',
    position: 'absolute',
    left: 0,
    right: 0,
  },
  fieldContainer: {
    flexDirection: 'row',
  },
  fieldLabel: {
    width: '50%',
    fontSize: 10,
    // fontWeight: 'semibold',
  },
  fieldValue: {
    width: '50%',
    fontSize: 10,
  },
  content: {
    fontSize: 10,
  }
});

const ReceiptPdf = ({ data }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.pageHeading}>
        <Text>SKA NANKANA SAHIB SOLICITORS</Text>
      </View>
      <View style={styles.headerSection}>
        <View style={styles.logoSection}>
          <Image
            style={{
              width: '60px',
              alignSelf: 'flex-end',
            }}
            src="/logo192.png"
          />
        </View>
        <View style={styles.companySection}>
          <Text style={{ alignSelf: 'flex-end', letterSpacing: 1, fontSize: 20, marginBottom: '5px' }}>Invoice</Text>
          <Text style={{ alignSelf: 'flex-end', fontSize: 8.5, marginBottom: 1 }}>In accordance with the fixed fee</Text>
          <Text style={{ alignSelf: 'flex-end', fontSize: 8.5 }}>agreement and terms of business.</Text>
        </View>
      </View>
      <View style={{ alignContent: 'flex-end', alignItems: 'flex-end', paddingRight: 10, marginTop: 10, marginBottom: 10, maxWidth: '50%', marginLeft: '50%' }}>
        <View style={styles.dateSection}>
          <View style={{ flexDirection: 'column', gap: 14, marginTop: 7 }}>
            <Text style={{ fontSize: 8 }}>Date:</Text>
            <Text style={{ fontSize: 8 }}>Reference Number:</Text>
          </View>
          <View style={{ flexDirection: 'column', gap: 4 }}>
            <Text style={{ border: '1px solid #222', fontSize: 10, padding: 2, width: 100 }}>{data.date}</Text>
            <Text style={{ border: '1px solid #222', fontSize: 10, padding: 2, width: 100 }}>AA/SK/BHAM/{data.fid}</Text>
          </View>
        </View>
      </View>


      <View style={styles.flexRowContent}>
        <View style={styles.leftSection}>
          <View style={styles.section}>
            <View style={styles.fieldContainer}>
              <Text style={{ fontWeight: 700, fontSize: 8, top: 6, width: '25%' }}>Client Name:</Text>
              <Text style={{ fontSize: 11, border: '1px solid #222', minHeight: 18, padding: 2, paddingLeft: 4, width: '80%' }}>{data.client_name}</Text>
            </View>
          </View>
          <View style={styles.section}>
            <View style={styles.fieldContainer}>
              <Text style={{ fontWeight: 700, fontSize: 8, top: 6, width: '25%' }}>Address:</Text>
              <Text style={{ fontSize: 11, border: '1px solid #222', minHeight: 18, padding: 2, paddingLeft: 4, width: '80%' }}>{data.address}</Text>
            </View>
          </View>
          <View style={styles.section}>
            <View style={styles.fieldContainer}>
              <Text style={{ fontWeight: 700, fontSize: 8, top: 6, width: '25%' }}>Phone:</Text>
              <Text style={{ fontSize: 11, border: '1px solid #222', minHeight: 18, padding: 2, paddingLeft: 4, width: '80%' }}>{data.phone}</Text>
            </View>
          </View>
          <View style={styles.section}>
            <View style={styles.fieldContainer}>
              <Text style={{ fontWeight: 700, fontSize: 8, top: 6, width: '25%' }}>Mobile:</Text>
              <Text style={{ fontSize: 11, border: '1px solid #222', minHeight: 18, padding: 2, paddingLeft: 4, width: '80%' }}>{data.mobile}</Text>
            </View>
          </View>
        </View>
      </View>

      <View>
        <Text style={{ marginVertical: 15, fontSize: 9, lineHeight: 1.3, color: '#222' }}>For the agreed fixed costs of your above referenced matter as per the instruction given on the file for a specific stage. This agreed fixed fee invoice is unalterable and payable forthwith alternatively within 28 days of issue. The interest will be charged on a daily basis at 8% per annum where payment is not made within 28 days of issue of this invoice.</Text>
      </View>

      <View style={styles.flexRowContent}>
        <View style={styles.leftSection + { width: '65%' }}>
          <View style={styles.section}>
            <View style={styles.fieldContainer}>
              <Text style={{ fontWeight: 700, fontSize: 8, top: 6, width: '19%' }}>Comments:</Text>
              <Text style={{ fontSize: 11, border: '1px solid #222', minHeight: 100, padding: 2, paddingLeft: 4, width: '81%' }}>{data.comments}</Text>
            </View>
          </View>
        </View>

        <View style={styles.rightSection}>
          <View style={styles.section}>
            <View style={styles.fieldContainer}>
              <Text style={{ fontWeight: 700, fontSize: 8, top: 6, width: '30%' }}>Sub Total:</Text>
              <Text style={{ fontSize: 11, border: '1px solid #222', minHeight: 18, padding: 2, paddingLeft: 4, width: '70%' }}>{'£' + data.sub_total}</Text>
            </View>
          </View>
          <View style={styles.section}>
            <View style={styles.fieldContainer}>
              <Text style={{ fontWeight: 700, fontSize: 8, top: 6, width: '30%' }}>VAT Total:</Text>
              <Text style={{ fontSize: 11, border: '1px solid #222', minHeight: 18, padding: 2, paddingLeft: 4, width: '70%' }}>{'£' + data.vat_total}</Text>
            </View>
          </View>
          <View style={styles.section}>
            <View style={styles.fieldContainer}>
              <Text style={{ fontWeight: 700, fontSize: 8, top: 6, width: '30%' }}>Grand Total:</Text>
              <Text style={{ fontSize: 11, border: '1px solid #222', minHeight: 18, padding: 2, paddingLeft: 4, width: '70%' }}>{'£' + data.grand_total}</Text>
            </View>
          </View>
          <View style={styles.section}>
            <View style={styles.fieldContainer}>
              <Text style={{ fontWeight: 700, fontSize: 8, top: 6, width: '30%' }}>Authorized Signature:</Text>
              <Text style={{ fontSize: 11, border: '1px solid #222', minHeight: 40, padding: 2, paddingLeft: 4, width: '70%' }}></Text>
            </View>
          </View>
          <View style={styles.section}>
            <View style={styles.fieldContainer}>
              <Text style={{ fontWeight: 700, fontSize: 8, top: 6 }}>Note: Fixed costs are agreed and payable
                as a contractual obligation.</Text>
            </View>
          </View>
        </View>
      </View>


      <View style={{ marginTop: 50 }}>
        <Text style={{ textAlign: 'center', fontSize: 10, marginVertical: 10 }}>THANK YOU FOR YOUR BUSINESS!</Text>
      </View>
      <View>
        <Text style={{ textAlign: 'center', fontSize: 13, marginBottom: 5 }}>SKA NANKANA SAHIB SOLICITORS</Text>
      </View>
      <View>
        <Text style={{ textAlign: 'center', fontSize: 7, marginBottom: 5 }}>101A Soho Hill, Hockley, Birmingham, B19 1AY</Text>
      </View>
      <View>
        <Text style={{ textAlign: 'center', fontSize: 7, marginBottom: 10 }}>Phone: 0121 493 4730-1 | Email: office@SKASolicitors.co.uk </Text>
      </View>
      <View>
        <Text style={{ textAlign: 'center', fontSize: 7, fontStyle: 'italic', marginBottom: 3 }}>SKA Nankana Sahib Solicitors is Authorised and Regulated by Solicitors Regulations Authority SRA: 659308 and is trading name of Thara Legal Ltd,</Text>
      </View>
      <View>
        <Text style={{ textAlign: 'center', fontSize: 7, fontStyle: 'italic' }}>Registered in England and Wales, Companies House No: 11906084, whose registered office is at 144 Desborough Road, High Wycombe, England, United Kingdom</Text>
      </View>


      <View style={{ position: 'absolute', bottom: 20, right: 20, left: 20, alignItems: 'flex-end' }}>
        <View style={{ display: 'flex', alignItems: 'flex-end' }}>
          <View style={{ gap: 2, fontSize: 8 }}>
            <Text style={{ fontWeight: 'bold', marginTop: 2 }}>
              Information:
            </Text>
            <Text style={{ marginTop: 2 }}>
              <Text style={{ fontWeight: 'bold' }}>i)</Text> <Text>We provide our services at a fair and reasonable cost to you.</Text>
            </Text>
            <Text style={{ marginTop: 2 }}>
              <Text style={{ fontWeight: 'bold' }}>ii)</Text> <Text>In Non-Contentious matters you have the right to ask us to apply to our regulatory body for a certificate if you are dissatisfied with the bill. You can obtain further information by getting in touch with Solicitors Regulation Authority. There are always changing time constraints for any application.</Text>
            </Text>
            <Text style={{ marginTop: 2 }}>
              <Text style={{ fontWeight: 'bold' }}>iii)</Text> <Text>Where the matter is contentious, under the Civil Procedure Rules, you are entitled to have the bill assessed (under Part III of the Solicitors Act 1974) by the court, time limitations apply.</Text>
            </Text>
            <Text style={{ marginTop: 2 }}>
              <Text style={{ fontWeight: 'bold' }}>iv)</Text> <Text>Where we have agreed a fixed fee with you for a stage or a complete matter, the above may not apply. We are also bound to work irrespective of the fact that the agreed work turns out to be more expensive for us than we had anticipated.</Text>
            </Text>
            <Text style={{ marginTop: 2 }}>
              <Text style={{ fontWeight: 'bold' }}>v)</Text> <Text>On hourly rate bills you are entitled to request us to provide the full schedule of incurred work.</Text>
            </Text>
            <Text style={{ marginTop: 2 }}>
              <Text style={{ fontWeight: 'bold' }}>vi)</Text> <Text>After expiry of 28 days from the date of dispatch of this bill, we can charge you interest on the outstanding amount from the date of the bill at the rate payable on judgement debts. This rate is currently 8% per annum.</Text>
            </Text>
          </View>
        </View>
      </View>
    </Page>
  </Document >
);

export default ReceiptPdf;
